export default function ProductsApprovalIcon(props) {
	return (
		<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10 0V1.8H9V14.4C9 16.389 7.21 18 5 18C2.79 18 1 16.389 1 14.4V1.8H0V0H10ZM6 11.7C5.448 11.7 5 12.1032 5 12.6C5 13.0968 5.448 13.5 6 13.5C6.552 13.5 7 13.0968 7 12.6C7 12.1032 6.552 11.7 6 11.7ZM4 9C3.448 9 3 9.4032 3 9.9C3 10.3968 3.448 10.8 4 10.8C4.552 10.8 5 10.3968 5 9.9C5 9.4032 4.552 9 4 9ZM7 1.8H3V5.4H7V1.8Z"
				fill="currentColor"
			/>
		</svg>
	);
}
